import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTrackRecentlyViewed } from '../../../../hooks/useTrackRecentlyViewed';
import { Loader } from '../../shared/components/Loader';
import { PageTitle } from '../../shared/components/PageTitle';
import { AddendumCard } from '../../shared/components/review-tab/AddendumCard';
import { ReviewAndSignButton } from '../../shared/components/review-tab/ReviewAndSignButton';
import { UnlockAppointmentButton } from '../../shared/components/review-tab/UnlockAppointmentButton';
import { useChartData } from '../../shared/hooks/useChartData';
import { useAppointmentData } from '../../shared/stores/appointment/appointment.store';
import { FollowUpNoteDetails } from '../components/follow-up-note/FollowUpNoteDetails';
import { FollowUpSummaryCard } from '../components/follow-up-note/FollowUpSummaryCard';

interface FollowUpNoteProps {
  appointmentID?: string;
}

export const FollowUpNote: React.FC<FollowUpNoteProps> = () => {
  const {
    patient,
    resources: { appointment },
    encounter,
    isAppointmentLoading,
    appointmentError,
    refetch,
  } = useAppointmentData();

  useTrackRecentlyViewed({ appointment, patient, encounter, isAppointmentLoading });

  const { isChartDataLoading, chartDataError } = useChartData();
  const isLoading = isAppointmentLoading || isChartDataLoading;
  const error = chartDataError || appointmentError;

  if (isLoading || isChartDataLoading) return <Loader />;
  if (error) return <Typography>Error: {error.message}</Typography>;
  if (!appointment) return <Typography>No data available</Typography>;

  return (
    <Stack spacing={1}>
      <PageTitle label="Follow-up Note" showIntakeNotesButton={false} />

      <FollowUpSummaryCard />

      <FollowUpNoteDetails />

      <AddendumCard />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <ReviewAndSignButton onSigned={refetch} />
          <UnlockAppointmentButton onUnlocked={refetch} />
        </Box>
      </Box>
    </Stack>
  );
};
